export const EDITAGENT_API_BASE =
  (import.meta.env.VITE_EDITAGENT_API_BASE as string | undefined) ??
  '/api/editagent/v1';
